import { apiSlice } from "../../app/api/apiSlice";

export const galleryApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    // =========================================
    // GET GALLERY IMAGES (PUBLIC)
    // =========================================
    getPublicGalleryImages: builder.query({

      query: ({ page = 1, limit = 12, event, category, year }) => {

        let url = `/api/v1/gallery/images?page=${page}&limit=${limit}`;

        if (event) url += `&event=${event}`;
        if (category) url += `&category=${category}`;
        if (year) url += `&year=${year}`;

        return url;
      },

      // cache key
      serializeQueryArgs: ({ endpointName, queryArgs }) => {

        return `${endpointName}-${queryArgs.event || "all"}-${queryArgs.category || "all"}-${queryArgs.year || "all"}`;

      },

      // infinite scroll merge
      merge: (currentCache, newItems) => {

        if (!currentCache?.data) {
          return newItems;
        }

        return {
          ...newItems,
          data: [
            ...currentCache.data,
            ...(newItems?.data || [])
          ]
        };

      },

      // refetch when filter changes
      forceRefetch({ currentArg, previousArg }) {

        return (
          currentArg?.event !== previousArg?.event ||
          currentArg?.category !== previousArg?.category ||
          currentArg?.year !== previousArg?.year
        );

      },

      providesTags: [{ type: "PublicGallery", id: "LIST" }],

    }),

    // =========================================
    // GET CATEGORIES
    // =========================================
    getGalleryCategories: builder.query({
      query: () => "/api/v1/gallery/categories",
      providesTags: [{ type: "GalleryCategory", id: "LIST" }],
    }),

    // =========================================
    // GET EVENTS
    // =========================================
    getGalleryEvents: builder.query({
      query: () => "/api/v1/gallery/events",
      providesTags: [{ type: "GalleryEvent", id: "LIST" }],
    }),

  }),
});

export const {
  useGetPublicGalleryImagesQuery,
  useGetGalleryCategoriesQuery,
  useGetGalleryEventsQuery,
} = galleryApiSlice;